import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import {
  markAsReaded,
  updateIsAllNotificationReaded,
} from '../../../redux/notifications/notifications.actions';

const NotificationItem = ({ id, text, isUnread, link }) => {
  const dispatch = useDispatch();
  const className = isUnread ? 'list__badge' : 'list__arrow';
  const handleMardAsReaded = () => {
    dispatch(markAsReaded(id));
    dispatch(updateIsAllNotificationReaded());
  };
  return (
    <li>
      <a
        href={!!link ? link : '#/'}
        target='_blank'
        rel='noreferrer'
        className='flex flex-ai-s'
        onClick={handleMardAsReaded}
      >
        <span className={className}></span>
        <p className='list__text'>{text}</p>
      </a>
    </li>
  );
};

NotificationItem.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  isUnread: PropTypes.bool.isRequired,
  link: PropTypes.string,
};

export default NotificationItem;
